import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'DocumentVisualization/List', method: 'POST', body: filter, token: token })
}
